import Error from "../../../Alerts/Error";
import Success from "../../../Alerts/Success";
import {useContext, useEffect, useState} from "react";
import Review from "./Review";
import {authContext} from "../../../../context/auth";
import {useParams} from "react-router-dom";
import {progressContext} from "../../../../context/progress";
import filterResponse from "../../../../filterResponse";
import canDeliver from "../../../../util/canDeliver";

export default function Delivery({goto, enabled, disable, job, hasEntryInputs}) {
	const [error, setError] = useState(null);
	const [success, setSuccess] = useState(null);
	const [loading, setLoading] = useState(false);
	const [confirmToDeliver, setConfirmToDeliver] = useState(false);

	const {id} = useParams();
	const {progress} = useContext(progressContext);

	async function onSubmit(evt) {
		evt.preventDefault();
		setLoading(true);
		setConfirmToDeliver(false);
		setError(null);
		setSuccess(null);

		try {
			const response = await fetch(process.env.REACT_APP_ENDPOINT + '/crowdJobSubmissions/deliver', {
				method: "PUT",
				headers: {
					"Content-Type": "application/json"
				},
				credentials: "include",
				body: JSON.stringify({
					crowdJobId: id,
					deliveryConfirmation: confirmToDeliver
				})
			});
			await filterResponse(response);

			if (response.status === 204) {
				disable(1);
				disable(2);
				setSuccess("Successfully delivered this job, you can close this tab. Your PM will let you know if any rework is needed.");
			}
			else if (response.status === 400) {
				const {error, confirmToDeliver} = await response.json();
				setError(error);
				if (confirmToDeliver) {
					setConfirmToDeliver(true);
				}
			}
			else {
				throw new Error("Wrong status");
			}
		}
		catch (e) {
			console.error(e);
			setError("Failed to deliver this job.");
		}

		setLoading(false);
	}

	// Nothing collected yet is the only reason to send them back to the entry tab; short of the
	// job's minimum they can still deliver, after confirming it.
	useEffect(() => {
		if (!canDeliver(progress) && enabled && hasEntryInputs) {
			goto(2);
		}
	}, [progress, enabled, hasEntryInputs]);

	useEffect(() => {
		const tab = document.getElementById("tab" + 3);
		let isMounted = true;

		tab.addEventListener("hidden.bs.tab", onHidden);
		tab.addEventListener("shown.bs.tab", onShown);

		function onShown() {
			document.getElementById("tab3-pane").classList.add("flex-fill", "d-flex",  "flex-column", "h-100");
			console.log("shown");
		}
		function onHidden() {
			document.getElementById("tab3-pane").classList.remove("flex-fill",  "d-flex",  "flex-column", "h-100");
			console.log("hidden");
		}

		return () => {
			tab.removeEventListener("shown.bs.tab", onShown);
			tab.removeEventListener("shown.bs.tab", onHidden);
			isMounted = false;
		};
	}, [id]);

	return (
		<div className={"flex-fill d-flex flex-column h-100"}>
			<h4>Delivery</h4>

			{error && <Error message={error} />}
			{success && <Success message={success} />}

			<form className={"flex-fill d-flex flex-column h-100"} onSubmit={onSubmit}>
				{!success && hasEntryInputs && <Review job={job} loading={loading} setLoading={setLoading} setError={setError} />}

				<div className={"mt-3 d-flex gap-2"}>
					<button type={"button"} className={"btn btn-secondary text-nowrap"} disabled={success} onClick={evt => {
						if (hasEntryInputs) {
							goto(2);
						}
						else {
							goto(1);
						}
					}}>&lt;- Previous</button>
					<button type={"submit"} className={"btn btn-success flex-fill"} disabled={loading || success}>Deliver</button>
				</div>
			</form>
		</div>
	);
}